import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const SubmissionSuccess = () => {
  const { applicationId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="success-container">
      <div className="success-card">
        <div className="success-icon">✓</div>
        <h2>Application Submitted Successfully!</h2>
        <div className="application-id">
          <strong>Application ID:</strong> {applicationId}
        </div>
        <p className="success-message">
          Our representative will review your application and call you within 48 hours.
          Please keep your application ID and mobile number for future reference.
        </p>
        <div className="success-buttons">
          <button onClick={() => navigate('/')} className="home-btn">Go to Home</button>
          <button onClick={() => navigate('/check-status')} className="new-btn">Check Status</button>
        </div>
      </div>
    </div>
  );
};

export default SubmissionSuccess;